import { Button, Spinner } from "reactstrap";
import classnames from "classnames";

const DropOffLocations = ({ locations }) => {
  return (
    <div>
      {locations.map(
        ({ label, address, distance, description, hours, image }) => (
          <div
            className="d-flex pt-3 pb-3 location-container border container mb-2 location-hover"
            onClick={() =>
              window.open(
                `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  address
                )}`,
                "_blank"
              )
            }
            style={{ cursor: "pointer" }}
          >
            <div
              className="location-image mr-4"
              style={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                minWidth: "150px",
                minHeight: "125px",
                borderRadius: "10px",
              }}
            ></div>
            <div className="location-info flex 1">
              <div className="small">{label}</div>
              <div className="">{address}</div>
              <div className="mt-2">
                <span className="badge badge-success">{distance} miles</span>
              </div>
              <div>{hours}</div>
              <div className="">{description}</div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default DropOffLocations;
